import {omit, pick} from 'lodash';

import {IntegrationSchemaTypesEnum} from '../../models/api/integrationTypesModel';

const expressionRefSchema = {
  type: IntegrationSchemaTypesEnum.OBJECT,
  properties: {
    expression: {
      type: 'string',
    },
  },
};

const stringTemplatePartSchema = {
  anyOf: [{type: 'string'}, expressionRefSchema],
};

const stringTemplateSchema = {
  type: IntegrationSchemaTypesEnum.OBJECT,
  properties: {
    template: {
      type: IntegrationSchemaTypesEnum.ARRAY,
      items: stringTemplatePartSchema,
    },
  },
};

const circleSchema = {
  type: IntegrationSchemaTypesEnum.STRING,
};

function buildAnyOf(param: any, ...alternativeSchemas: any) {
  return {
    anyOf: [pick(param, 'type', 'format', 'mustExist'), ...alternativeSchemas],
    ...omit(param, 'type', 'format', 'mustExist'),
  };
}

export function injectExpressionSchema(param: any): any {
  if (param.type === 'array') {
    return {
      ...param,
      items: injectExpressionSchema(param.items),
    };
  }

  // Skip if already an expression.
  if (param.type === 'string' && param.format === 'expression') {
    return param;
  }

  // String templates.
  if (param.type === 'string') {
    return buildAnyOf(param, stringTemplateSchema);
  }

  // Teammates and circles.
  if (param.type === 'number' && param.format === 'teammate') {
    return buildAnyOf(param, expressionRefSchema, circleSchema);
  }

  return buildAnyOf(param, expressionRefSchema);
}
